import { FC, useEffect, useRef, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import { ICreateRecommendPlace } from "../../interface/recommend-place";

interface IAddRecommendPlaceModal {
  show: boolean;
  toggle: Function;
  onSubmit: (data: ICreateRecommendPlace) => void;
}

const AddRecommendPlaceModal: FC<IAddRecommendPlaceModal> = ({
  show,
  toggle,
  onSubmit,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [reqAddPlace, setReqAddPlace] = useState<ICreateRecommendPlace>({
    name: "",
    description: "",
    lat: 0,
    lng: 0,
    status: 1,
    picture: "",
  });
  const [imagePreview, setImagePreview] = useState<string>("");

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const base64String = event.target?.result as string;
        setReqAddPlace((prev) => ({
          ...prev,
          picture: base64String,
        }));
        setImagePreview(base64String);
      };
      reader.readAsDataURL(file);
    }
  };

  const removeImage = () => {
    setReqAddPlace((prev) => ({
      ...prev,
      picture: "",
    }));
    setImagePreview("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(reqAddPlace);
  };

  useEffect(() => {
    if (show) {
      setReqAddPlace({
        name: "",
        description: "",
        lat: 0,
        lng: 0,
        status: 1,
        picture: "",
      });
      setImagePreview("");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  }, [show]);

  return (
    <Modal size="lg" isOpen={show} toggle={() => toggle()} centered={false}>
      <div className="modal-title modal-header">
        <h5 className="modal-title">เพิ่มสถานที่แนะนำ</h5>
        <button
          type="button"
          onClick={() => toggle()}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <div className="border-bottom mb-3">
            <div className="form-group row">
              <div className="col-12 col-md-3">
                <label className="required">ชื่อสถานที่</label>
              </div>
              <div className="col-12 col-md-9 col-lg-8">
                <input
                  className="form-control"
                  type="text"
                  required
                  value={reqAddPlace.name}
                  onChange={(e) =>
                    setReqAddPlace((prev) => ({
                      ...prev,
                      name: e.target.value,
                    }))
                  }
                />
              </div>
            </div>

            <div className="form-group row">
              <div className="col-12 col-md-3">
                <label>คำอธิบาย</label>
              </div>
              <div className="col-12 col-md-9 col-lg-8">
                <textarea
                  className="form-control"
                  rows={4}
                  value={reqAddPlace.description}
                  onChange={(e) =>
                    setReqAddPlace((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }))
                  }
                />
              </div>
            </div>

            <div className="form-group row">
              <div className="col-12 col-md-3">
                <label className="required">ละติจูด</label>
              </div>
              <div className="col-12 col-md-9 col-lg-8">
                <input
                  className="form-control"
                  type="number"
                  step="any"
                  required
                  value={reqAddPlace.lat || ""}
                  onChange={(e) =>
                    setReqAddPlace((prev) => ({
                      ...prev,
                      lat: parseFloat(e.target.value) || 0,
                    }))
                  }
                />
              </div>
            </div>

            <div className="form-group row">
              <div className="col-12 col-md-3">
                <label className="required">ลองจิจูด</label>
              </div>
              <div className="col-12 col-md-9 col-lg-8">
                <input
                  className="form-control"
                  type="number"
                  step="any"
                  required
                  value={reqAddPlace.lng || ""}
                  onChange={(e) =>
                    setReqAddPlace((prev) => ({
                      ...prev,
                      lng: parseFloat(e.target.value) || 0,
                    }))
                  }
                />
              </div>
            </div>

            <div className="form-group row">
              <div className="col-12 col-md-3">
                <label>สถานะ</label>
              </div>
              <div className="col-12 col-md-9 col-lg-8">
                <select
                  className="form-control"
                  value={reqAddPlace.status}
                  onChange={(e) =>
                    setReqAddPlace((prev) => ({
                      ...prev,
                      status: parseInt(e.target.value),
                    }))
                  }
                >
                  <option value={1}>เปิดใช้งาน</option>
                  <option value={0}>ปิดใช้งาน</option>
                </select>
              </div>
            </div>

            <div className="form-group row">
              <div className="col-12 col-md-3">
                <label>รูปภาพ</label>
              </div>
              <div className="col-12 col-md-9 col-lg-8">
                <input
                  ref={fileInputRef}
                  type="file"
                  className="form-control-file"
                  accept="image/*"
                  onChange={handleImageChange}
                />
                {imagePreview && (
                  <div className="mt-2">
                    <img
                      src={imagePreview}
                      alt="Preview"
                      style={{
                        width: "200px",
                        height: "150px",
                        objectFit: "cover",
                        borderRadius: "4px",
                      }}
                    />
                    <div className="mt-2">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        onClick={removeImage}
                      >
                        ลบรูปภาพ
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="modal-footer px-0 pb-0">
            <button
              type="button"
              onClick={() => toggle()}
              className="btn btn-light"
            >
              ยกเลิก
            </button>
            <button type="submit" className="btn btn-primary">
              บันทึก
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default AddRecommendPlaceModal;
